import React from "react";
import { Box } from "@mui/material";
import Alerts from "./Alerts";
import AlertsGroup from "./AlertsGroup";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { clearFilter } from "../../store/actions/alertsGroup";
import { useDispatch } from "react-redux";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx = {{marginTop : "24px"}} >{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const AlertsPage = () => {
    const dispatch = useDispatch();
    const [value, setValue] = React.useState(0);


    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue === 1) {
            dispatch(
                clearFilter()
            )
        }
    };

    return (
        <Box
            sx={{
                minHeight: "65vh",
                margin: "0 auto",
                display: "flex",
                flexDirection: "column",
                width: "100%",
            }}
        >
            <h2
                className="page-common-heading_tittle"
            >
                Alerts
            </h2>

            <Box sx={{ borderBottom: 1, borderColor: 'divider', textTransform: "none" }}>
                <Tabs className='alertsTab' value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab sx={{ textTransform: "none", marginLeft: "-10px", borderBottom: value !== 0 ? "1px solid #D8DADA" : "none", }} disableRipple style={{ fontSize: '20px !important' }} label="Default Alerts" {...a11yProps(0)} />
                    <Tab sx={{ textTransform: "none", borderBottom: value !== 1 ? "1px solid #D8DADA" : "none", }} disableRipple style={{ fontSize: '20px !important' }} label="Alert Groups" {...a11yProps(1)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <Alerts />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <AlertsGroup />
            </CustomTabPanel>
        </Box>
    );
};

export default AlertsPage;
